<template>
  <div class="tm-scope tp-review" @click="closeAllChats">
    <div class="tp-review__inner">
      <h1 class="fw-bolder">Your Standardized Skills</h1>
      <div class="tp-review__list" @click.stop>
        <div class="tp-row-head">
          <span>Your Input</span>
          <span>Standard Version</span>
        </div>
        <div v-for="(item,i) in skills" :key="i" class="tp-row">
          <div class="tp-row__input">{{ item.input }}</div>
          <div class="tp-row__field">
            <input
              type="text"
              v-model="item.output"
              class="tp-row__output"
              @click="item.showDropdown = !item.showDropdown"
              @input="filterOptions(item)"
              @blur="handleBlur(item,i)"
            />
            <div class="tp-row__actions">
              <button type="button" class="tp-icon-btn tp-icon-btn--danger" aria-label="Delete" @click="deleteItem(item.skillid)">
                <FontAwesomeIcon icon="fa-solid fa-trash-can" />
              </button>
              <div class="tp-row__ai">
                <button type="button" class="tp-icon-btn" aria-label="Ask AI" title="Ask AI for a suggestion" @click.stop="AiPost(item,i)">
                  <img src="../../assets/images/home/ai.png" class="tp-row__ai-icon" alt="">
                </button>
                <AiSuggestionBubble
                  :visible="item.showChat"
                  :loading="isLoading"
                  :html="typedText"
                  @like="setAiData(i)"
                  @dislike="item.showChat = false; typedText = ''"
                />
              </div>
            </div>
            <SuggestionDropdown
              :items="item.other ? item.other[0] : []"
              :visible="item.showDropdown && !!item.other"
              @select="(option) => selectOption(option, item)"
            />
          </div>
        </div>
      </div>

      <div class="tp-add-new">
        <h6 class="text-start"><strong>Add new item</strong></h6>
        <div class="tp-add-new__row">
          <input type="text" class="tp-add-new__input" v-model="newItem">
          <button class="btn-light-blue" @click="addList()">
            <Spinner v-if="spinner" :size="16" />
            <span v-else>Add</span>
          </button>
        </div>
      </div>

      <div class="tp-review__footer">
        <button class="tm-btn-secondary" @click="router.push({name:'landing-page'})">Back to Home</button>
        <button class="tm-btn-primary" @click="downloadCSV()">Download as CSV</button>
      </div>
    </div>
  </div>
</template>

<script>
import { UserInfoApiService } from "@/services/UserInfoApiService";
import Swal from "sweetalert2";
import { computed, defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import SuggestionDropdown from "@/components/SuggestionDropdown.vue";
import AiSuggestionBubble from "@/components/AiSuggestionBubble.vue";
import Spinner from "@/components/Spinner.vue";

export default defineComponent({
  components:{FontAwesomeIcon, SuggestionDropdown, AiSuggestionBubble, Spinner},
  setup() {
    library.add(faTrashCan,faThumbsUp,faThumbsDown)
    const inputValue = ref(""); // مقدار ورودی کاربر
    const options = ref(["Option 1", "Option 2", "Option 3"]); // گزینه‌های دراپ‌دان
    const filteredOptions = ref([...options.value]); // گزینه‌های فیلتر شده
    const skills = ref()
    const newItem = ref()
    const other_results = ref([])
    const main_result = ref()
    const router = useRouter()
    const spinner = ref(false)
    const showChat = ref(false)
    const itemSelected = ref([])
    const isLoading = ref(false);
    const fullText = computed(() => `I've unearthed
      ${`<a href="#" class="result-option" data-value="${main_result.value}">${main_result.value}</a>`}
      from the depths of our database! Is this result satisfactory? Alternatively,
      ${other_results.value.map(result => `<a href="#" class="result-option" data-value="${result}">${result}</a>`).join(', ')}
      also look similar. You can just click on the one you prefer and press the like button below.`);
    const typedText = ref('');
    const typingSpeed = ref(30);

    // انتخاب گزینه
    function selectOption(option,item) {
      item.output = option;
      item.showDropdown = false;
      let skill_flag = 0;
      UserInfoApiService.EditSkills([{'_id':item.skillid,'skill':item.output,'skill_flag':skill_flag}])
    }

    // فیلتر کردن گزینه‌ها
    function filterOptions(item) {
      const search = item.output.toLowerCase();
      filteredOptions.value = options.value.filter((option) =>
        option.toLowerCase().includes(search)
      );
    }

    // بستن دراپ‌دان هنگام خروج فوکوس
    function handleBlur(item,i) {
      setTimeout(() => {
        let skill_flag = 1;
          for (let i = 0; i < item.other[0].length; i++) {
            if (item.output==item.other[0][i]) {
              skill_flag = 0;
            }
            console.log(item.other[0][i],item.output,item.output==item.other[0][i]);
          }
        UserInfoApiService.EditSkills([{'_id':item.skillid,'skill':item.output,'skill_flag':skill_flag}])
        item.showDropdown = false;
        skills.value[i] = item
      }, 200);
    }

    function closeAllChats() {
      // NOTE: this previously read `this.skills` inside setup(), where `this` is
      // undefined (Composition API has no `this`) — that threw on every click and
      // silently no-opped this function. Fixed to use the `skills` ref in scope,
      // otherwise AI bubbles (and the click-away close behavior) never worked.
      skills.value.forEach((skill) => {
        skill.showChat = false;
      });
      other_results.value = [];
      main_result.value = '';
      typedText.value = '';
    }

    onMounted(() => {
      if (UserInfoApiService.skills) {
        skills.value = UserInfoApiService.skills.map((skill) => {
          let other;
          try {
            // بررسی و پردازش مقدار other
            other = skill.other !== "None" ? skill.other : skill.other;
          } catch (error) {
            console.error("Error parsing JSON:", skill.other, error);
            other = []; // مقدار پیش‌فرض در صورت نامعتبر بودن JSON
          }
          return {
            ...skill,
            showDropdown: false, // اضافه کردن خاصیت showDropdown به هر آیتم
            showChat: false,
            other: skill.other !== 'None' ? JSON.parse(skill.other) : skill.other,
          };
        });
      }
      else {
        Swal.fire({
          title: "warning!",
          text: "Your changes have been saved in your profile section. To make changes again, please go to your profile section",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        }).then((result)=>{
          if (result.isConfirmed) {
            router.push({name:'dashboard-standardization',params:{id:localStorage.getItem('user_id')}})
          }
        })
      }

      document.addEventListener("click", (event) => {
        const target = event.target;

        if (target.classList.contains("result-option")) {
          event.preventDefault(); // جلوگیری از تغییر آدرس لینک
          const selectedValue = target.getAttribute("data-value");

          if (selectedValue&&itemSelected.value.length!=0) {
            itemSelected.value[0].output = selectedValue;
          }
        }
      });
    });

    function deleteItem(id){
      UserInfoApiService.DeleteSkill(id).then((res)=> {
        if (res.status==200) {
          skills.value = skills.value.filter(item => item.skillid !== id);
        }
      })
    }

    function addList(){
      spinner.value = true
      let addSkill = []
      addSkill.push(newItem.value)
      UserInfoApiService.saveSkills(addSkill,localStorage.getItem('user_id')).then((res)=>{
          if (res.status==200) {
            res.data.processed_skills[0].showDropdown = false
            res.data.processed_skills[0].other = JSON.parse(res.data.processed_skills[0].other)
          }
          skills.value.push(res.data.processed_skills[0])
          spinner.value = false;
          newItem.value = '';
      })
    }

    function downloadCSV() {
      // 1. ایجاد سرآیند CSV
      const headers = ["Your Input", "Standard Version"];

      // 2. تبدیل داده‌ها به رشته CSV
      const rows = skills.value.map((item) => [item.input, item.output]);
      const csvContent = [
        headers.join(","), // اضافه کردن سرآیندها
        ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")), // داده‌ها
      ].join("\n");

      // 3. ایجاد فایل Blob از داده CSV
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      // 4. ایجاد لینک دانلود
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "skills.csv");
      link.style.display = "none";
      document.body.appendChild(link);

      // 5. شروع دانلود و پاکسازی لینک
      link.click();
      document.body.removeChild(link);
    }

    function AiPost(params,i) {
      // NOTE: same `this.skills` fix as closeAllChats() above.
      skills.value.forEach((skill) => {
        skill.showChat = false;
      });
      other_results.value = [];
      main_result.value = '';
      typedText.value = '';
      skills.value[i].showChat = true;
      isLoading.value = true;
      itemSelected.value[0] = params;
      itemSelected.value[1] = i;
      UserInfoApiService.aiSkills(params.input).then((res)=>{
        if (res.status==200) {
          other_results.value = res.data.result.other_results;
          main_result.value = res.data.result.main_result;
          isLoading.value = false;
        }
        startTyping();
      })
    }

    function startTyping() {
      typedText.value = ''; // متن را از اول شروع می‌کنیم
      let index = 0;
      if (main_result.value && other_results.value) {
        const interval = setInterval(() => {
        if (index < fullText.value.length) {
          typedText.value += fullText.value[index];
          index++;
        } else {
          clearInterval(interval);
        }
        }, typingSpeed.value);
      }
      else {
        let text = 'There is no reponse for the desired item'
        const interval = setInterval(() => {
        if (index < text.length) {
          typedText.value += text[index];
          index++;
        } else {
          clearInterval(interval);
        }
        }, typingSpeed.value);
      }
    }

    function setAiData(i){
      typedText.value = '';
      handleBlur(itemSelected.value[0],itemSelected.value[1]);
      skills.value[i].showChat=false;
      if (other_results.value) {
        if (!skills.value[itemSelected.value[1]].other) {
          skills.value[itemSelected.value[1]].other = [0]
        }
        skills.value[itemSelected.value[1]].other[0] = other_results.value;
        skills.value[itemSelected.value[1]].other[0].push(main_result.value);
      }
    }

    return {
      inputValue,
      options,
      filteredOptions,
      skills,
      router,
      newItem,
      spinner,
      showChat,
      other_results,
      main_result,
      typedText,
      fullText,
      typingSpeed,
      itemSelected,
      isLoading,
      setAiData,
      startTyping,
      AiPost,
      downloadCSV,
      addList,
      deleteItem,
      selectOption,
      filterOptions,
      handleBlur,
      closeAllChats
    };
  },
});
</script>

<style scoped>
.tp-review {
  min-height: 100dvh;
  background-color: var(--tm-canvas);
  padding: 8% 24px 64px;
}

.tp-review__inner {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}



.tp-review__list {
  text-align: left;
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  border-radius: 20px;
  padding: 8px 20px;
}

.tp-row-head {
  display: flex;
  justify-content: space-between;
  padding: 12px 4px 6px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--tm-ink-faint);
}

.tp-row {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 14px 4px;
  border-top: 1px solid var(--tm-border);
}

.tp-row__input {
  flex: 0 0 38%;
  color: var(--tm-ink-muted);
  font-size: 0.9rem;
}

.tp-row__field {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tp-row__output {
  flex: 1;
  border: none;
  border-bottom: 1px solid var(--tm-border-strong);
  background: transparent;
  padding: 6px 2px;
  font-size: 0.95rem;
  color: var(--tm-ink);
  outline: none;
  transition: border-color 0.15s ease;
}

.tp-row__output:focus {
  border-bottom-color: var(--tm-accent-bright);
}

.tp-row__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tp-row__ai {
  position: relative;
}

.tp-row__ai-icon {
  width: 20px;
  border-radius: var(--tm-radius-xs);
  display: block;
}

.tp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: var(--tm-radius-sm);
  background: transparent;
  color: var(--tm-ink-muted);
  cursor: pointer;
  transition: background 0.15s ease;
}

.tp-icon-btn:hover {
  background: var(--tm-surface-hover);
}

.tp-icon-btn--danger {
  color: var(--tm-danger);
}

.tp-add-new {
  text-align: left;
  border-radius: var(--tm-radius-lg);
  background: var(--tm-surface);
  border: 1px solid var(--tm-border);
  padding: 20px;
  margin: 24px 0;
}

.tp-add-new__row {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.tp-add-new__input {
  flex: 1;
  border: none;
  border-bottom: 1px solid var(--tm-border-strong);
  background: transparent;
  padding: 8px 2px;
  outline: none;
}

.tp-review__footer {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
